var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{staticStyle:{"margin":"30px"},attrs:{"type":"primary"},on:{"click":_vm.clear}},[_vm._v("清除数据并退出登录")])
}
var staticRenderFns = []

export { render, staticRenderFns }